export const clusterLabelStyle = {
  layout: {
    'text-field': '{point_count}',
    'text-font': ['AmsiProCond-Regular', 'Arial Unicode MS Bold'],
    'text-size': 28,
    'text-anchor': 'center',
    'text-allow-overlap': true,
    'text-ignore-placement': true,
  },
  paint: {
    'text-color': '#d97a09',
  },
};

export const clusterStyle = {
  paint: {
    'circle-color': 'rgb(255, 255, 255)',
    'circle-radius': 25,
    'circle-stroke-width': 4,
    'circle-stroke-color': '#d97a09',
    'circle-translate': [0, -1],
  },
};

export const unclusteredPointStyle = {
  paint: {
    'circle-color': 'rgb(255, 255, 255)',
    'circle-radius': 5,
    'circle-stroke-width': 5,
    'circle-stroke-color': '#d97a09',
  },
};
